// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Radiooooo

// What exists before anyone has signed in, and all a visitor downloads: the
// session, the language, the plain client and the auth that signs in over
// it. The rest of the core (boot/core.ts) is a listener's and arrives with
// the frame, built on this.

import { createLifetime } from "../core/lifetime";
import { pipe } from "../core/compose";
import { withApi } from "./features/withApi";
import { withAuth } from "./features/withAuth";
import { withI18n } from "./features/withI18n";
import { withSession } from "./features/withSession";

export type Foundation = ReturnType<typeof createFoundation>;

export function createFoundation() {
    const foundation = pipe(
        // ── Foundation: no dependencies of their own ──
        withSession(),
        withI18n(),

        // ── The wire, first half: the plain client, then what can refresh a token over it ──
        withApi(),
        withAuth(),
    )({});
    const lifetime = createLifetime();
    lifetime.onDestroy(foundation.i18n.cancel);
    // Invalidate outstanding account requests before disposing their observers.
    lifetime.onDestroy(() => { foundation.auth.destroy(); foundation.session.crossBoundary(); });
    return { ...foundation, destroy: lifetime.destroy };
}
